const PERIODS = [
  { label: '7 dias', value: '7d' as const },
  { label: '30 dias', value: '30d' as const },
  { label: '90 dias', value: '90d' as const },
];

interface PeriodFilterProps {
  value: '7d' | '30d' | '90d';
  onChange: (period: '7d' | '30d' | '90d') => void;
}

export function PeriodFilter({ value, onChange }: PeriodFilterProps) {
  return (
    <div className="flex gap-1 rounded-md border p-1">
      {PERIODS.map((p) => (
        <button
          key={p.value}
          onClick={() => onChange(p.value)}
          className={`rounded px-3 py-1 text-xs font-medium transition-colors ${
            value === p.value
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
